





























import { User } from '@/types/Users'
import { Vue, Component, Prop } from 'vue-property-decorator'
import GMap from '@/components/GMap.vue'

@Component({
  components: {
    GMap,
  },
})
export default class UserPreview extends Vue {
  @Prop({ required: true }) user!: User
  @Prop({ default: false }) showMap!: boolean
}
